import { httpClient } from '@/infra/protocols/http';
import { IHostVoiceDTO } from '@/modules/episodes/dtos/host.dto';
import { HostMapper } from '@/modules/episodes/mappers/host.mapper';

import { type IHostVoice } from '../entities/host.entity';

export namespace PutHostsService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }
  export interface Payload {
    quantity: number;
  }
  export type Response = IHostVoice[];
}

export async function updateHostsQuantity(
  params: PutHostsService.Params,
  data: PutHostsService.Payload,
): Promise<PutHostsService.Response> {
  const body = {
    quantidade: data.quantity,
  };

  const response = await httpClient.put<IHostVoiceDTO[]>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/hosts`,
    body,
  );
  return response.map(HostMapper.toPresentation);
}
